import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  static readonly targets = ["container", "template"];
  static readonly values = {
    length: {
      type: Number,
      default: 0,
    },
  };

  declare readonly hasTemplateTarget: boolean;
  declare readonly templateTarget: HTMLElement;
  declare readonly hasContainerTarget: boolean;
  declare readonly containerTarget: HTMLElement;
  declare readonly lengthValue: number;

  private _length = 0;

  connect(): void {
    this._length = this.lengthValue;
  }

  duplicate(event: Event) {
    event.preventDefault();

    if (this.hasContainerTarget && this.hasTemplateTarget) {
      let content = this.templateTarget.innerHTML;
      content = content.replace(/NEW_RECORD/g, `${this._length}`);
      this.containerTarget.insertAdjacentHTML("beforeend", content);

      this._length += 1;
    }
  }
}
